module.exports = __webpack_public_path__ + "static/media/red_marker.1e536552.png";